import * as React from 'react';
import { NodeTypes } from '@src/interfaces/nodes';
import stateComponents from '@state/components';
import Element from './_Element';
import BoxAtom from './Box';
import InputAtom from './Input';
import TextAtom from './Text';
import IconAtom from './Icon';
function Atoms({ component, parent, tilted, index }) {
    if (component.type === NodeTypes.Element) {
        const element = Object.assign(Object.assign({}, stateComponents.find((el) => el.id === component.elementId).root), { columnStart: component.columnStart, columnEnd: component.columnEnd, rowStart: component.rowStart, rowEnd: component.rowEnd });
        return React.createElement(Element, { component: element, parent: component, tilted: tilted, index: index });
    }
    if (component.type === NodeTypes.Box) {
        return React.createElement(BoxAtom, { component: component, parent: parent, tilted: tilted, index: index });
    }
    if (component.type === NodeTypes.Text) {
        return React.createElement(TextAtom, { component: component, parent: parent, tilted: tilted, index: index });
    }
    if (component.type === NodeTypes.Input) {
        return React.createElement(InputAtom, { component: component, parent: parent, tilted: tilted, index: index });
    }
    if (component.type === NodeTypes.Icon) {
        return React.createElement(IconAtom, { component: component, parent: parent, tilted: tilted, index: index });
    }
}
export default Atoms;
